<h2 mat-dialog-title>
  Sélectionner un équipment standard (provenant de la bibliothèque).
</h2>
<app-list-lib-equipment
  [actions]="['select', 'search', 'referenceFilterable']"
  (select)="close($event)">
</app-list-lib-equipment>
